import { useState } from 'react';
import { IconUp, IconDown, formatDate } from '@ui/src';
import { DeviceItemTypes } from './types';
import { Device } from '../../../hoc/settings/profile/types';

import cn from './styles.module.css';

const UserDevice = ({
  device,
  endSessionsIsAvailable,
  endSession,
  endSessionId,
  endSessionInProgress,
  sessionsIsAvailable,
  onViewSessionClick,
}: DeviceItemTypes) => {
  const [collapsed, setCollapsed] = useState(false);

  const date = device?.updatedAt ? device?.updatedAt : device?.createdAt;

  return (
    <div className={cn.deviceItem}>
      <button
        type="button"
        className={cn.deviceItemButton}
        onClick={() => setCollapsed(!collapsed)}
      >
        <div className={cn.deviceItemButtonLeft}>
          <div className={cn.deviceItemButtonTitle}>
            {`${device?.platform} - ${device?.browser}`}
            {device?.isCurrent && (
              <div className={cn.currentSession}>(Current session)</div>
            )}
          </div>
          <div className={cn.deviceItemButtonDate}>
            {formatDate(date as string, true)}
          </div>
        </div>
        {collapsed ? (
          <IconUp width={14} height={11} />
        ) : (
          <IconDown width={14} height={11} />
        )}
      </button>
      {collapsed && (
        <div className={cn.deviceInfo}>
          <div className={cn.deviceInfoRow}>
            <div className={cn.deviceInfoTitle}>OS</div>
            <div className={cn.deviceInfoValue}>
              {device?.platform || 'Unknown OS'}
            </div>
          </div>
          <div className={cn.deviceInfoRow}>
            <div className={cn.deviceInfoTitle}>Browser:</div>
            <div className={cn.deviceInfoValue}>
              {device?.browser || 'Unknown browser'}
            </div>
          </div>
          <div className={cn.deviceInfoRow}>
            <div className={cn.deviceInfoTitle}>Creation date:</div>
            <div className={cn.deviceInfoValue}>
              {formatDate(date as string, true)}
            </div>
          </div>
          <div className={cn.deviceInfoRow}>
            <div className={cn.deviceInfoTitle}>IP address:</div>
            <div className={cn.deviceInfoValue}>
              {device?.ip || 'Unknown IP address'}
            </div>
          </div>
          <div className={cn.deviceControls}>
            {sessionsIsAvailable && (
              <button
                type="button"
                className={`${cn.endSession} ${cn.viewSessions}`}
                onClick={() => onViewSessionClick(device as Device)}
              >
                View sessions
              </button>
            )}
            {endSessionsIsAvailable && (
              <button
                type="button"
                className={cn.endSession}
                onClick={() => endSession(device?.id as string)}
              >
                {endSessionInProgress && endSessionId === device?.id
                  ? 'Loading...'
                  : 'End session'}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDevice;
